import axios from '@/api/axios-config'
import type { ShiftRequest, ShiftRequestCreateData, ShiftRequestReviewData } from './types'
import type { SearchResponse } from '@/features/list-page/types'

export const shiftRequestApi = {
  searchShiftRequests: (params: any) =>
    axios.post<any, SearchResponse<ShiftRequest>>('/pms/schedule-requests/search', params),

  getShiftRequest: (id: string, loadRelationships?: string[]) => {
    const params = new URLSearchParams()
    loadRelationships?.forEach(r => params.append('load_relationships', r))
    return axios.get<any, ShiftRequest>(`/pms/schedule-requests/${id}?${params.toString()}`)
  },

  createShiftRequest: (data: ShiftRequestCreateData) =>
    axios.post<any, ShiftRequest>('/pms/schedule-requests', data),

  approveShiftRequest: (id: string, data?: ShiftRequestReviewData) =>
    axios.put<any, ShiftRequest>(`/pms/schedule-requests/${id}/approve`, data || {}),

  rejectShiftRequest: (id: string, data?: ShiftRequestReviewData) =>
    axios.put<any, ShiftRequest>(`/pms/schedule-requests/${id}/reject`, data || {}),

  cancelRequest: (id: string) =>
    axios.delete<any, void>(`/pms/schedule-requests/${id}`),
}
